import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHealth = () => {
  return (
    <g>
      <path d="M3.75 0a.75.75 0 0 1 0 1.5H2.528v3.765a3.985 3.985 0 0 0 7.966.199l.005-.2-.001-3.764H9.25a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .707 1.001L11.999 1v4.265A5.486 5.486 0 0 1 7.25 10.7v1.549a2.25 2.25 0 0 0 4.07 1.323 2.125 2.125 0 1 1 1.358.668 3.75 3.75 0 0 1-6.923-1.792l-.005-.199v-1.553a5.487 5.487 0 0 1-4.717-5.211l-.005-.221V1l.015.001A.749.749 0 0 1 1.75 0h2zm9.125 11.5a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25z" />
    </g>
  );
};

export default withIcon(IconHealth);
